import { TimerCallback } from '@commons/core/format/models/timer';
import { IContact } from '@commons/models/contact';
import { RxUtil } from '@commons/util/utilities/rx';
import { Actions, ofType } from '@ngrx/effects';
import { IPromise, IQService } from 'angular';
import { first, merge, mergeMap, Observable, throwError } from 'rxjs';

import { BookingFacade, InterContactAction, InterContactService, TimerService } from '@contact/upgrade';

const MODULE_NAME = 'interContactDeprecatedService';

/**
 *  @deprecated, prefer BookingFacade
 */
export interface IInterContactDeprecatedService {
  /**
   * @deprecated, prefer TimerService.timer
   */
  start(responseId: string, callback: TimerCallback): void;

  /**
   * @deprecated, prefer TimerService.timer
   */
  start$(responseId: string): Observable<number>;

  /**
   * @deprecated, prefer InterContactService.canInterrupt
   */
  canInterrupt(contact: IContact): boolean;

  /**
   * @deprecated, prefer BookingFacade.stopInterContact
   */
  finish(responseId: string): IPromise<any>;
}

/**
 *  @deprecated, prefer BookingFacade
 */
export class InterContactDeprecatedService implements IInterContactDeprecatedService {
  static $inject: Array<string> = ['$q', 'interContactService', 'timerService', 'contactFacade', 'ngrxActionService'];

  public name = MODULE_NAME;

  constructor(
    private readonly $q: IQService,
    private readonly interContactService: InterContactService,
    private readonly timerService: TimerService,
    private readonly contactFacade: BookingFacade,
    private readonly actions$: Actions
  ) {}

  /**
   * @deprecated, prefer TimerService.timer
   */
  start(responseId: string, callback: TimerCallback): void {
    this.timerService
      .startChrono(InterContactService.toTimerId(responseId), {
        tags: [responseId],
      })
      .subscribe({
        next: timer => callback(timer),
        complete: () => callback(0),
      });
  }

  /**
   * @deprecated, prefer TimerService.timer
   */
  start$(responseId: string): Observable<number> {
    return this.timerService.timer(InterContactService.toTimerId(responseId));
  }

  /**
   * @deprecated, prefer InterContactService.canInterrupt
   */
  canInterrupt(contact: IContact): boolean {
    return this.interContactService.canInterrupt(contact);
  }

  /**
   * @deprecated, prefer BookingFacade.stopInterContact
   */
  finish(responseId: string): IPromise<any> {
    this.contactFacade.stopInterContact(responseId);
    const success$ = this.actions$.pipe(ofType(InterContactAction.StopSuccess), first());
    const fail$ = this.actions$.pipe(
      ofType(InterContactAction.StopFail),
      mergeMap(() => throwError(() => 'fail'))
    );
    return RxUtil.toPromise(merge(success$, fail$), this.$q);
  }
}

export default MODULE_NAME;
